import { useEffect } from 'react';

import Sidebar from './components/Sidebar/Sidebar';
import './app.css'
import { Routes, Route } from "react-router-dom";

import Overview from './components/Overview/Overview';
import Interaction from './components/Interaction/Interaction';
import RoomLogsPage from './components/RoomLogsPage/RoomLogsPage';
import ZoomMeetings from './components/ZoomMeetings/ZoomMeetings';
import ZoomInteractions from './components/ZoomInteractions/ZoomInteractions';
// import Meetings from './components/Meetings/Meetings';
// import Participants from './components/Participants/Participants';
// import Topbar from './components/Topbar/Topbar';

import { DashboardOutlined, DuoOutlined, AnalyticsOutlined } from '@mui/icons-material';
import CssBaseline from '@mui/material/CssBaseline';
import Analytics from './components/Analytics/Analytics';
// import { makeStyles } from '@mui/styles';
import styled from '@emotion/styled'

import { LicenseInfo } from '@mui/x-license-pro';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: 'flex',
//     '& .MuiTableCell-body': {
//       fontFamily: "'Source Sans Pro', sans- serif"
//     }
//   }
// }));

const Container = styled.div(props => ({
  display: 'flex',
  '& .MuiTableCell-body': {
    fontFamily: "'Source Sans Pro', sans- serif"
  }
}))

const PrivateRoutesConfig = [
  {
    component: Overview,
    path: '/',
    icon: <DashboardOutlined fontSize="large" />,
    exact: true,
  }, {
    component: Interaction,
    path: '/interaction/:meetingId',
    title: 'Interaction Monitoring',
  },
  // {
  //   component: ZoomMeetings,
  //   icon: <DuoOutlined fontSize="large" />,
  //   path: '/zoom',
  //   title: 'Zoom Meetings',
  // }, 
  {
    component: RoomLogsPage,
    path: '/room-logs/:meetingId',
    title: 'Room Activity Logs',
  }, {
    component: ZoomInteractions,
    path: '/zoom-interaction/:meetingId',
    title: 'Zoom Interaction Monitoring',
  }, {
    component: Analytics,
    path: '/analytics',
    icon: <AnalyticsOutlined fontSize="large" />,
    title: 'Analytics',
  }
  // , {
  //   component: Meetings,
  //   path: '/meeting/:meetingId',
  //   title: 'Meeting',
  // }, {
  //   component: Participants,
  //   path: '/room/:roomId',
  //   title: 'Participant',
  // }
];

function MapAllowedRoutes({ routes, isAddNotFound }) {
  return (
    <Routes>
      {routes.map((route) => {
        const {
          path,
          component: Component,
          children,
          title,
          permission,
          ...rest
        } = route;

        return (
          <Route
            key={path}
            path={`${path}`}
            element={<Component children={children} />}
          />
        )
      })}

      {/* {isAddNotFound && <Route><NotFound /></Route>} */}
      {isAddNotFound && <Route path="*" element={<Overview />} />}  {/*Temporary redirected to Overview page */}
    </Routes>
  )
}

function isArrayWithLength(arr) {
  return (Array.isArray(arr) && arr.length)
}

function getAllowedRoutes(routes, userRole) {
  return routes.filter(({ permission }) => {
    if (!permission) {
      return true;
    } else if (!isArrayWithLength(permission)) {
      return true;
    } else {
      const intersected = permission.filter(value => value === userRole);
      return intersected.length;
    }
  });
}

function App() {
  // const classes = useStyles();

  let allowedRoutes = process.env.REACT_APP_MOCK_AUTH === 'true' ? PrivateRoutesConfig : getAllowedRoutes(PrivateRoutesConfig, 'admin');

  const mui_key = cookies.get('mui_key') || process.env.REACT_APP_MUI_KEY;
  if (mui_key) {
    LicenseInfo.setLicenseKey(mui_key);
  }
  useEffect(() => {
  }, [])

  return (
    <Container>
      {/* <Topbar /> */}
      <CssBaseline />
      <Sidebar
        routes={allowedRoutes}
      />
      <div style={{ flexGrow: 1, overflow: 'auto' }}>
        <MapAllowedRoutes
          routes={allowedRoutes}
          isAddNotFound
        />
      </div>
    </Container>
  );
}

export default App;
